import { createI18n } from "./createI18n.js";
import { enAUMessages } from "./messages/enAUMessages.js";
import { enGBMessages } from "./messages/enGBMessages.js";
import { enUsMessages } from "./messages/enUSMessages.js";

export type MessageFn = ReturnType<typeof useI18n>["msg"];

const { I18nProvider, useI18n } = createI18n(
  new Intl.Locale("en"),
  enGBMessages,
);

const supportedLanguages = ["en-GB", "en-US", "en-AU"] as const;

const provideMessages = (locale: Intl.Locale) => {
  switch (locale.toString()) {
    case "en": {
      return enGBMessages;
    }
    case "en-GB": {
      return enGBMessages;
    }
    case "en-US": {
      return enUsMessages;
    }
    case "en-AU": {
      return enAUMessages;
    }
    default: {
      return null;
    }
  }
};
export { I18nProvider, useI18n, supportedLanguages, provideMessages };
